import { HFlow, Text } from 'bold-ui'
import { CustomSelectFieldProps, SelectField } from 'components/form/core'
import { DEFAULT_SELECT_PAGE_PARAM, useAsyncQuerySelect } from 'components/form/field/select/useAsyncQuerySelect'
import { EquipeAdSelectFieldDocument } from 'graphql/hooks.generated'
import { EquipeAdSelectFieldQuery, EquipeAdSelectFieldQueryVariables } from 'graphql/types.generated'

export type EquipeSelectModel = EquipeAdSelectFieldQuery['equipesAD']['content'][0]

export type EquipeSelectFieldProps = CustomSelectFieldProps<EquipeSelectModel> & {
  localidadeId?: ID
  equipeId?: ID
  mostrarEquipesRelacionadas?: boolean
}

export function EquipeAdSelectField(props: EquipeSelectFieldProps) {
  const { localidadeId, equipeId, mostrarEquipesRelacionadas, ...rest } = props

  const { selectProps } = useAsyncQuerySelect<
    EquipeSelectModel,
    EquipeAdSelectFieldQuery,
    EquipeAdSelectFieldQueryVariables
  >({
    query: EquipeAdSelectFieldDocument,
    fetchPolicy: 'cache-first',
    extractItems: (data) => data?.equipesAD?.content,
    variables: (inputQuery) => ({
      input: {
        query: inputQuery,
        mostrarEquipesRelacionadas,
        localidadeId,
        equipeId,
        pageParams: {
          ...DEFAULT_SELECT_PAGE_PARAM,
          sort: ['nome'],
        },
      },
    }),
  })

  const itemToString = (option: EquipeSelectModel) => option?.nome

  const renderItem = (item: EquipeSelectModel) => (
    <>
      <Text fontWeight='bold'>
        {item.nome?.capitalize()} – {item.tipoEquipe.sigla}
      </Text>
      <HFlow hSpacing={0.5}>
        <Text fontWeight='bold'>INE:</Text>
        {item.ine}
      </HFlow>
    </>
  )

  return (
    <SelectField<EquipeSelectModel> itemToString={itemToString} renderItem={renderItem} {...selectProps} {...rest} />
  )
}
